import Swiper from "swiper";
import {
    Autoplay,
    Navigation,
    Pagination,
    Thumbs,
    FreeMode,
    Mousewheel,
    EffectFade,
    Keyboard,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import imagesLoaded from "imagesloaded";
window.imagesLoaded = imagesLoaded;
window.Swiper = Swiper;

/* Caroselli sotto la piega: costruirli al caricamento vuol dire pagare init,
   cloni del loop e autoplay mentre il browser sta ancora disegnando la prima
   schermata. Misurato sulla home con emulazione mobile: .swiper_evidence sta a
   2,1 schermate di distanza con 10 slide e .swiper_scelte_per_te a 3,7 con 30,
   e Swiper valeva da solo 1615 ms di thread principale.

   La galleria della scheda NON passa di qui: quella e' in cima alla pagina e
   deve esserci subito. Il margine di 400 px fa partire la costruzione prima che
   il carosello si veda, cosi' chi scorre lo trova gia' pronto. */
function quandoVisibile(elemento, crea) {
    if (!elemento) {
        return;
    }
    if (!("IntersectionObserver" in window)) {
        crea();
        return;
    }

    const osservatore = new IntersectionObserver(
        (voci) => {
            if (voci.some((voce) => voce.isIntersecting)) {
                osservatore.disconnect();
                crea();
            }
        },
        { rootMargin: "400px" },
    );
    osservatore.observe(elemento);
}

const containers_visualizzate_consigliate_bodytype_selection =
    document.querySelectorAll(
        ".swiperVisualizzate, .swiperConsigliate, .bodytype_selection_homepage",
    );

containers_visualizzate_consigliate_bodytype_selection.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 3;
    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 4000,
                  },
              }
            : {}),
        slidesPerView: 1,
        spaceBetween: 15,
        grabCursor: true,
        speed: 1350,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            450: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            996: { slidesPerView: 2 },
            1200: { slidesPerView: 3 },
            1600: { slidesPerView: 4 },
        },
    });
});

const single_container = document.querySelectorAll(
    ".swiper-promo-homepage, .swiper-promo-service",
);

single_container.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length >= 2;
    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 4000,
                  },
              }
            : {}),
        slidesPerView: 1,
        spaceBetween: 20,
        grabCursor: true,
        speed: 1500,
        touchRatio: 1,
        allowTouchMove: true,
        pagination: {
            el: container.querySelector(".swiper-pagination"),
            clickable: true,
        },
        navigation: {
            nextEl: container.querySelector(".swiper-button-next"),
            prevEl: container.querySelector(".swiper-button-prev"),
        },
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});

const blocchi_garanzie_lista = document.querySelectorAll(
    ".swiper-blocchi-garanzie-lista",
);

/* Blocchi garanzie lista */
blocchi_garanzie_lista.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let conteggio_desktop = 4;
    if (slides.lehgth > 4) {
        conteggio_desktop = 5;
    }
    let enableLoop = slides.length > 3;
    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 2000,
                  },
              }
            : {}),
        grabCursor: true,
        speed: 1500,
        slidesPerView: 2,
        spaceBetween: 0,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            370: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: conteggio_desktop,
            },
            1600: {
                slidesPerView: conteggio_desktop,
            },
        },
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});

const altre_offerte_lista = document.querySelectorAll(
    ".swiper-altre-offerte-lista",
);
/* Altre offerte nella lista */
altre_offerte_lista.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 3;
    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 4000,
                  },
              }
            : {}),
        grabCursor: true,
        speed: 1500,
        slidesPerView: 1,
        spaceBetween: 0,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            450: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            996: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 3,
            },
            1600: {
                slidesPerView: 4,
            },
        },
    });
});

const altre_offerte_lista_preferiti = document.querySelectorAll(
    ".swiper-altre-offerte-lista-preferiti",
);

/* Altre offerte nella lista */
altre_offerte_lista_preferiti.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 6;
    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 4000,
                  },
              }
            : {}),
        grabCursor: true,
        speed: 1500,
        slidesPerView: 1,
        spaceBetween: 10,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            450: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            996: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 5,
            },
            1600: {
                slidesPerView: 5,
            },
        },
    });
});

const swiper_warranties_search_engine = document.querySelectorAll(
    ".swiper_warranties_search_engine",
);

/* Bottoni Garanzie su motore di ricerca */
swiper_warranties_search_engine.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 3;

    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 1500,
                  },
              }
            : {}),
        slidesPerView: 3,
        grabCursor: true,
        spaceBetween: 10,
        disableOnInteraction: true,
        speed: 1800,
        touchRatio: 1,
        allowTouchMove: true,
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});

const swiper_newsflash = document.querySelectorAll(".swiper_newsflash");

// /* NewsFlash */
swiper_newsflash.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 1;

    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 1500,
                  },
              }
            : {}),
        slidesPerView: 1,
        grabCursor: true,
        disableOnInteraction: true,
        speed: 900,
        touchRatio: 1,
        allowTouchMove: true,
        on: {
            init: function () {
                var prevButton = this.navigation.$prevEl;
                var nextButton = this.navigation.$nextEl;

                $(prevButton).addClass("swiper-button-prev_white");
                $(nextButton).addClass("swiper-button-next_white");
            },
        },
    });
});

/* Gallery Thumbs */
const swiper_scheda_full_thumbs = new Swiper(".swiper-scheda-thumbs", {
    modules: [Navigation, Thumbs, FreeMode, Autoplay, Mousewheel],
    loop: true,
    spaceBetween: 5,
    mousewheel: true,
    freeMode: true,
    ...(import.meta.env.PROD
        ? {
              autoplay: {
                  delay: 1500,
              },
          }
        : {}),
    speed: 1800,
    watchSlidesProgress: true,
    touchRatio: 1,
    allowTouchMove: true,
    breakpoints: {
        0: { slidesPerView: 4 },
        768: { slidesPerView: 6 },
        1024: { slidesPerView: 8 },
        1440: { slidesPerView: 8 },
    },
});

/* Gallery */
const swiper_scheda_full = new Swiper(".swiper-scheda", {
    modules: [Navigation, Thumbs, Mousewheel],
    loop: true,
    ...(import.meta.env.PROD
        ? {
              autoplay: {
                  delay: 600,
              },
          }
        : {}),
    speed: 500,
    mousewheel: true,
    spaceBetween: 0,
    touchRatio: 1,
    allowTouchMove: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: {
        swiper: swiper_scheda_full_thumbs,
    },
});

const altre_offerte = new Swiper(".swiper-altre-offerte", {
    modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
    loop: true,
    ...(import.meta.env.PROD
        ? {
              autoplay: {
                  delay: 4000,
              },
          }
        : {}),
    grabCursor: true,
    speed: 1500,
    slidesPerView: 1,
    spaceBetween: 5,
    touchRatio: 1,
    allowTouchMove: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        450: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 3,
        },
        996: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 4,
        },
        1600: {
            slidesPerView: 4,
        },
    },
});

// /* Stock nelle landing */
const stock_landing = document.querySelectorAll(".swiper-stock-landing");

stock_landing.forEach((container) => {
    // /* Stock nelle landing */
    new Swiper(container, {
        modules: [Autoplay, Navigation, Mousewheel],
        slidesPerView: 3,
        spaceBetween: 20,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 1800,
                  },
              }
            : {}),
        speed: 500,
        loop: true,
        // mousewheel: true,
        grabCursor: true,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 2 },
            1440: { slidesPerView: 3 },
        },
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});

// /* Slider Immagini Landing page */
const swiper_slider_landing = new Swiper(".swiper-slider-landing", {
    modules: [Autoplay, Navigation, Mousewheel],
    slidesPerView: 1,
    spaceBetween: 20,
    ...(import.meta.env.PROD
        ? {
              autoplay: {
                  delay: 2500,
              },
          }
        : {}),
    speed: 2000,
    loop: true,
    mousewheel: true,
    grabCursor: true,
    touchRatio: 1,
    allowTouchMove: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

// /* Slider Video Youtube e Vimeo */
const video_landing = new Swiper(".swiper-video-landing", {
    modules: [Navigation, Pagination, Mousewheel],
    slidesPerView: 1,
    spaceBetween: 40,
    autoplay: false,
    speed: 850,
    loop: true,
    mousewheel: true,
    grabCursor: true,
    touchRatio: 1,
    allowTouchMove: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 40 },
        768: { slidesPerView: 1, spaceBetween: 40 },
        1024: { slidesPerView: 2, spaceBetween: 40 },
        1440: { slidesPerView: 2, spaceBetween: 50 },
    },
});

const swiperBrands = new Swiper(".swiper-landing-brands", {
    modules: [Navigation, Pagination, Mousewheel],
    slidesPerView: 1,
    spaceBetween: 40,
    autoplay: {
        delay: 10000,
    },
    speed: 850,
    loop: true,
    // mousewheel: true,
    grabCursor: true,
    touchRatio: 1,
    allowTouchMove: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        0: { slidesPerView: 2, spaceBetween: 10 },
        768: { slidesPerView: 3, spaceBetween: 20 },
        1024: { slidesPerView: 4, spaceBetween: 40 },
        1440: { slidesPerView: 6, spaceBetween: 10 },
    },
});

quandoVisibile(document.querySelector(".swiper_evidence"), () => new Swiper(".swiper_evidence", {
    modules: [Navigation, Pagination, Mousewheel],
    slidesPerView: 3,
    spaceBetween: 0,
    autoplay: {
        delay: 2000,
    },
    speed: 1250,
    centeredSlides: false,
    mousewheel: false,
    grabCursor: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        "@0.00": {
            slidesPerView: 1.2,
            spaceBetween: 20,
            centeredSlides: true,
        },
        "@0.75": {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        "@1.00": {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        1400: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        1750: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
    },
}));

quandoVisibile(document.querySelector(".swiper_scelte_per_te"), () => new Swiper(".swiper_scelte_per_te", {
    modules: [Navigation, Pagination, Mousewheel],
    slidesPerView: 3,
    spaceBetween: 0,
    autoplay: {
        delay: 2000,
    },
    speed: 1250,
    centeredSlides: false,
    mousewheel: false,
    grabCursor: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        "@0.00": {
            slidesPerView: 1.2,
            spaceBetween: 20,
            centeredSlides: true,
        },
        "@0.75": {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        // "@1.00": {
        //     slidesPerView: 2.5,
        //     spaceBetween: 20,
        // },
        1400: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        1750: {
            slidesPerView: 3.5,
            spaceBetween: 20,
        },
    },
}));

const swiper_top_car = new Swiper(".swiper-top-car", {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    effect: "fade",
    autoplay: {
        delay: 3500,
        disableOnInteraction: false,
    },
    fadeEffect: {
        crossFade: true,
    },
    slidesPerView: 1,
    speed: 1500,
    grabCursor: true,
    pagination: {
        el: ".swiper-top-car .swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-top-car .swiper-button-next",
        prevEl: ".swiper-top-car .swiper-button-prev",
    },
    on: {
        init: function () {
            setTimeout(() => {
                const container = document.querySelector(".swiper-top-car");
                if (container) {
                    container.classList.remove("invisible");
                    container.classList.add("visible");
                }
            }, 250);
        },
    },
});

const swiper_offerte_in_evidenza = new Swiper(".swiper-offerte-in-evidenza", {
    modules: [Navigation, Pagination, Mousewheel],
    slidesPerView: 3,
    spaceBetween: 0,
    autoplay: {
        delay: 2000,
    },
    speed: 1250,
    centeredSlides: false,
    mousewheel: false,
    grabCursor: true,
    pagination: {
        el: ".swiper-offerte-in-evidenza .swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-offerte-in-evidenza .swiper-button-next",
        prevEl: ".swiper-offerte-in-evidenza .swiper-button-prev",
    },
    breakpoints: {
        "@0.00": {
            slidesPerView: 1.2,
            spaceBetween: 40,
            // centeredSlides: true,
        },
        "@0.75": {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        "@1.00": {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        1400: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        1750: {
            slidesPerView: 5,
            spaceBetween: 20,
        },
    },
});

const swiperModels = new Swiper(".swiper-landing-models", {
    modules: [Navigation, Pagination, Mousewheel],
    slidesPerView: 1,
    spaceBetween: 40,
    autoplay: {
        delay: 10000,
    },
    speed: 850,
    loop: true,
    // mousewheel: true,
    grabCursor: true,
    touchRatio: 1,
    allowTouchMove: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 10 },
        768: { slidesPerView: 2, spaceBetween: 20 },
        1024: { slidesPerView: 2, spaceBetween: 40 },
        1440: { slidesPerView: 3, spaceBetween: 10 },
    },
});

/* TOP CAR — Galleria della scheda
   Miniature sotto la foto grande in swiper, e galleria a schermo intero
   aperta cliccando la foto grande. Gira solo sulla scheda Top Car. */
const top_car_gallery = document.querySelector(".top-car .gallery");

if (top_car_gallery) {
    const stage_image = document.getElementById("top-car-gallery");
    const thumbs_el = top_car_gallery.querySelector(".thumbs");
    const thumb_buttons = top_car_gallery.querySelectorAll(".thumb");

    /* Miniature sotto la foto grande */
    if (thumbs_el) {
        new Swiper(thumbs_el, {
            modules: [Navigation, FreeMode, Mousewheel],
            slidesPerView: "auto",
            spaceBetween: 12,
            freeMode: true,
            watchOverflow: true,
            mousewheel: { forceToAxis: true },
            navigation: {
                nextEl: thumbs_el.querySelector(".swiper-button-next"),
                prevEl: thumbs_el.querySelector(".swiper-button-prev"),
            },
        });
        setTimeout(() => {
            thumbs_el.classList.add("visible");
        }, 250);
    }

    /* Click su una miniatura: cambia la foto grande */
    thumb_buttons.forEach((thumb) => {
        thumb.addEventListener("click", () => {
            const src = thumb.getAttribute("data-image");
            if (!src || !stage_image) return;

            stage_image.src = src;
            thumb_buttons.forEach((t) => t.classList.remove("is-active"));
            thumb.classList.add("is-active");
        });
    });

    /* Galleria a schermo intero */
    const top_car_modal = document.getElementById("top-car-gallery-modal");

    if (top_car_modal) {
        const full_el = top_car_modal.querySelector(".full");
        const full_thumbs_el = top_car_modal.querySelector(".full-thumbs");

        const top_car_full_thumbs = full_thumbs_el
            ? new Swiper(full_thumbs_el, {
                  modules: [FreeMode, Thumbs],
                  slidesPerView: "auto",
                  spaceBetween: 10,
                  freeMode: true,
                  watchSlidesProgress: true,
              })
            : null;

        const top_car_full = new Swiper(full_el, {
            modules: [Navigation, Pagination, Thumbs, Keyboard, Mousewheel],
            spaceBetween: 0,
            keyboard: { enabled: true },
            mousewheel: { forceToAxis: true },
            navigation: {
                nextEl: full_el.querySelector(".swiper-button-next"),
                prevEl: full_el.querySelector(".swiper-button-prev"),
            },
            pagination: {
                el: full_el.querySelector(".swiper-pagination"),
                type: "fraction",
            },
            ...(top_car_full_thumbs
                ? { thumbs: { swiper: top_car_full_thumbs } }
                : {}),
        });

        /* Dentro un modal chiuso le misure sono a zero: al momento
           dell'apertura ricalcola e si posiziona sulla foto già visibile */
        top_car_modal.addEventListener("shown.bs.modal", () => {
            const active = top_car_gallery.querySelector(".thumb.is-active");
            const index = active ? Number(active.dataset.index) || 0 : 0;

            top_car_full.update();
            if (top_car_full_thumbs) top_car_full_thumbs.update();
            top_car_full.slideTo(index, 0);
        });
    }
}
